import * as helpers from '../helpers';
import l10n from '../lang/locallang';

export default class SearchContent {
    constructor(selector, config = null) {
        this.selector = selector;
        this.config = {
            search: null,
            searchButton: null,
            item: null,
        };

        if (config instanceof Object) {
            this.config = helpers.extendDefaults(this.config, config);
        }

        if (this.config.search && this.config.searchButton && this.config.item) {
            this.button = document.querySelector(this.config.searchButton);
            this.items = document.querySelectorAll(this.config.item);

            this.checkBeforeInit();
        } else {
            console.log('Not all config are filled in this object');
        }
    }

    checkBeforeInit() {
        if (typeof this.selector !== 'string') {
            return this.selector === null ? false : this.init();
        }

        if (typeof this.selector === 'string') {
            const els = document.querySelectorAll(this.selector);

            if (els === null) {
                return;
            }

            for (let i = 0; i < els.length; i++) {
                const el = new SearchContent(els[i], this.config);
            }
        }
    }

    init() {
        const fields = [];

        this.button.addEventListener('click', (event) => {
            event.preventDefault();

            let count = 0;

            // Check number of fields
            for (let i = 0; i < this.config.search.length; i++) {
                const field = document.querySelector(this.config.search[i]);

                fields[i] = field;
            }

            for (let i = 0; i < this.items.length; i++) {
                // Array with terms
                const itemsTermes = Array.from(this.items[i].querySelectorAll('.js-terme'), itemsTerme => itemsTerme.textContent.toUpperCase());

                // Dual search
                if ((fields[0].value.length > 0) && (fields[1].value.length > 0)) {
                    if (
                        (
                            (typeof itemsTermes[0] !== 'undefined') && (itemsTermes[0].indexOf(fields[0].value.toUpperCase()) >= 0)
                        )
                        && (
                            ((typeof itemsTermes[1] !== 'undefined')
                                && (itemsTermes[1].indexOf(fields[1].value.toUpperCase()) >= 0)
                            )
                            || (
                                (typeof itemsTermes[2] !== 'undefined')
                                    && (itemsTermes[2].indexOf(fields[1].value.toUpperCase()) >= 0)
                            )
                            || (
                                (typeof itemsTermes[3] !== 'undefined')
                                    && (itemsTermes[3].indexOf(fields[1].value.toUpperCase()) >= 0)
                            )
                            || (
                                // Default option on the select
                                fields[1].value === '0'
                            )
                        )
                    ) {
                        this.showElement(this.items[i]);
                        count += 1;
                    } else {
                        this.hideElement(this.items[i]);
                    }
                } else if ((fields[0].value.length === 0) && (fields[1].value.length > 0)) { // Search on the second field
                    if (
                        (
                            (typeof itemsTermes[1] !== 'undefined')
                                && (itemsTermes[1].indexOf(fields[1].value.toUpperCase()) >= 0)
                        )
                        || (
                            (typeof itemsTermes[2] !== 'undefined')
                                && (itemsTermes[2].indexOf(fields[1].value.toUpperCase()) >= 0)
                        )
                        || (
                            (typeof itemsTermes[3] !== 'undefined')
                                && (itemsTermes[3].indexOf(fields[1].value.toUpperCase()) >= 0)
                        )
                        || (
                            // Default option on the select
                            fields[1].value === '0'
                        )
                    ) {
                        this.showElement(this.items[i]);
                        count += 1;
                    } else {
                        this.hideElement(this.items[i]);
                    }
                } else if ((fields[0].value.length > 0) && (fields[1].value.length === 0)) { // Search on the first field
                    if (
                        ((typeof itemsTermes[0] !== 'undefined') && (itemsTermes[0].indexOf(fields[0].value.toUpperCase()) >= 0))
                    ) {
                        this.showElement(this.items[i]);
                        count += 1;
                    } else {
                        this.hideElement(this.items[i]);
                    }
                } else if (fields[0].value.length === 0 && fields[1].value.length === 0) { // empty
                    this.showElement(this.items[i]);
                    count += 1;
                }
            }
            this.updateListResults(count);
        });

        this.initlistResults();
    }

    hideElement(item) {
        item.classList.add('-hide');
    }

    showElement(item) {
        item.classList.remove('-hide');
    }

    results(count) {
        let plural = '';

        if (count > 1) {
            plural = 's';
        }

        if (count === 0) {
            return `${l10n.noResult}`;
        }

        return `${l10n.displaying} ${count} ${l10n.result}${plural} ${l10n.of} ${this.items.length}`;
    }

    initlistResults() {
        const noResultPTemp = this.selector.querySelector('.js-number-articles');
        const count = this.items.length;

        if (!noResultPTemp) {
            const list = this.selector;
            const listParent = list.parentNode;
            const noResultP = document.createElement('p');
            helpers.addClass(noResultP, ['js-number-articles', 'number-articles']);
            noResultP.setAttribute('aria-live', 'polite');

            listParent.insertBefore(noResultP, list);

            document.querySelector('.js-number-articles').innerHTML = this.results(count);
        }
    }

    updateListResults(count) {
        document.querySelector('.js-number-articles').innerHTML = this.results(count);
        this.noResults();
    }

    noResults() {
        const titles = this.selector.querySelectorAll('.contact .title');

        for (let i = 0; i < titles.length; i++) {
            const title = titles[i];

            for (let j = 0; j < title.nextElementSibling.children.length; j++) {
                if (!title.nextElementSibling.children[j].classList.contains('-hide')) {
                    title.classList.remove('-hide');
                    break;
                } else {
                    title.classList.add('-hide');
                }
            }
        }
    }
}
